/*eslint-disable*/
import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet-async";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Parallax from "components/Parallax/Parallax.js";
import { headApi } from "utils/headApi";
import { localApi } from "utils/headApi";
import landingPageStyle from "assets/jss/material-kit-pro-react/views/landingPageStyle.js";
import SectionPolaBangles from "./SectionPolaBangles";
import BanglesContactpage from "./Contact";
import PolaBanglesHeader from "./PolaBanglesHeader";
import PolaBanglesHeaderLinks from "./PolaBanglesHeaderLinks";
import PolaBanglesFooter from "./PolaBanglesFooter";
import PolaBlog from "./PolaBlog";
import PolaPosts from "./PolaPosts";
const useStyles = makeStyles(landingPageStyle);

export default function BanglesLandingpage() {
  const [products, setProducts] = useState([]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });

  const history = useHistory();

  const userSession = JSON.parse(sessionStorage.getItem("sessionData"));
  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  const currentUrl = "https://polabangles.com/";
  const seoTitle =
    "POLA BANGLES | Imitation Jewellery Manufacturer & Exporter in India";
  const seoDescription =
    "POLA BANGLES is a leading imitation jewellery manufacturer and exporter in India, offering stylish bangles, fashion jewellery, and wholesale designs for every occasion.";
  const seoKeywords =
    "POLA BANGLES is a leading imitation jewellery manufacturer and exporter based in Malad, Mumbai, India, offering stylish bangles in sizes such as 1mm, 2mm, 3mm, 4mm, 5mm, 5/2.5mm, 6mm, 6/3mm, 7mm, 7/3.5mm, 8mm, 8/4mm, 9mm, 9/4.5mm, 10mm, 10/5mm, 11mm, 11/5.5mm, 12mm, 12/6mm, 13mm, 13/6.5mm, 14mm, 14/7mm, 15mm, 15/7.5mm, 16mm, 16/8mm, 17mm, 17/8.5mm, 18mm, 18/9mm, 19mm, 19/9.5mm, 20mm, 20/10mm, and 25mm, including gold-plated items such as micro gold plating, tri-colour plating, 7 semanario sets, 3-tone plating, rose gold plating, rhodium plating, and silver plating. We also offer gold-plated meenakari bangles, 2-tone bangles, new Mexican bangles, gold-plated/oro laminado products, hoop earrings (round, big, and modern styles), 3-tone plated bangles, 3-tone U earrings, women’s earrings, animal-designed bangles, kids’ baby 6mm tri-colour bangles, Seven Day (Semanario) bangle bracelets, Mexican 14K gold bangles, three-tone bangles, dual-tone dolphin bypass bangles, dual-tone bangles, fashion jewellery, and wholesale designs for every occasion.";
  const ogImage =
    "https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png";

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "POLA BANGLES",
    url: "https://polabangles.com",
    logo: "https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png",
    sameAs: ["https://polabangles.com"],
  };

  const handleLogOut = () => {
    const finalURL =
      localApi + `/otp/logout/registerById/${userObj && userObj.id}`;
    fetch(finalURL, {
      method: "PUT",
      // headers: {
      //   "content-type": "application/json",
      //   accept: "application/json",
      // },
    })
      .then((response) => response.json())
      .then((response) => {
        // console.log(response);
        if (response.error === true) {
          sessionStorage.removeItem("sessionData");
          history.push("/");
          window.location.reload(false);
        }
      })
      .catch((err) => {
        console.log(err);
        // console.log();
      });
  };

  // if (!products) return null;

  const ClickHandler = () => {
    ReactGa.event({
      category: "Button",
      action: "Click on the landing page",
      // country: 'India',
    });
    // alert('thank you for visiting the website contact us')
    // console.log(alert);
  };

  const classes = useStyles();
  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={currentUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="POLA BANGLES" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={ogImage} />

        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
      </Helmet>
      <PolaBanglesHeader
        // color="white"
        brand="Home"
        links={<PolaBanglesHeaderLinks dropdownHoverColor="danger" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 400,
          color: "danger",
        }}
      />
      <Parallax
        image={require("assets/img/Landing.jpg").default}
        filter="dark"
      >
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <h1 className={classes.title}>Pola Bangles</h1>
              <h4>
                Bangles are more than accessories for Indian women. It is a
                tradition to wear Pola Bangles after marriage in various states
                of India like Maharashtra, West Bengal, Odisha, Rajasthan, and
                Gujarat. A Red Pola bangle signifies energy and prosperity,
                while a green Pola denotes good luck and fertility and White
                Pola Bangles symbolize peace and happiness.
              </h4>
              <h4>
                Click on the link to check our{" "}
                <Link
                  color="danger"
                  // size="lg"
                  href="/#"
                  // {`/products-page?id=${prod.id}&catdesc=${prod.cat.description}&cat1desc=${prod.banglessizemm.description}&Plating=${prod.platingList.map((p) => (p.description.slice(8)))}`}
                  // target="_blank"
                >
                  {/* <i className="fas fa-play" /> */}
                  Special offers
                </Link>
              </h4>
              <br />
              <Button
                color="danger"
                // size="lg"
                href="/pola-signup-page"
                // target="_blank"
                onClick={ClickHandler}
              >
                sign up
              </Button>{" "}
              {!userSession ? (
                <Button
                  color="danger"
                  // size="lg"
                  href="/pola-login-page"
                  // target="_blank"
                >
                  {/* <i className="fas fa-play" /> */}
                  log in
                </Button>
              ) : (
                <Button
                  color="danger"
                  onClick={handleLogOut}
                  // size="lg"
                  // href="/"
                  // target="_blank"
                >
                  log out
                </Button>
              )}
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <SectionPolaBangles />
          <PolaPosts />
          <div>
            <PolaBlog />
          </div>
        </div>
        <BanglesContactpage />
        {/* <FormEmail/>       */}
      </div>
      <PolaBanglesFooter />
    </div>
  );
}
